import React, { useState, useEffect } from 'react';
import { fetchOrganizations } from '../../../api/backend';
import { Table, TableBody, TableCell, TableContainer,
     TableHead, TableRow, Paper, TextField, Select, MenuItem,
      IconButton, Avatar, Chip, Pagination, Button } from '@mui/material';
import { Visibility, Edit, Delete, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ref, uploadBytes, getDownloadURL, db, storage, collection, addDoc, getDocs,
    query, orderBy, startAfter, limit } from '../../../api/firebase';

const Organization = () => {
  const [organizations, setOrganizations] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('');
  const [filter, setFilter] = useState('All');
  const navigate = useNavigate();

  useEffect(() => {
    loadOrganizations();
  }, [page, search, sort, filter]);

  const loadOrganizations = async () => {
    let q;
    if (lastVisible && page > 1) {
      q = query(collection(db, "organizations"), orderBy("name"), startAfter(lastVisible), limit(5));
    } else {
      q = query(collection(db, "organizations"), orderBy("name"), limit(5));
    }

    const querySnapshot = await getDocs(q);
    const orgList = [];
    querySnapshot.forEach((doc) => {
      orgList.push({ id: doc.id, ...doc.data() });
    });
    setOrganizations(orgList);
    setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    //setPage(1);
  };

  const handleSortChange = (event) => {
    setSort(event.target.value);
    setPage(1);
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setPage(1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleCreateClick = () => {
    navigate('/admin/organization/create');
  };
  
  const handleManage = (orgId) => {
    console.log('Manage organization:', orgId);
    navigate('/admin/organization/manager/' + orgId);
};

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active': return 'success';
      case 'Inactive': return 'warning';
      //case 'Cancelled': return 'error';
      default: return 'default';
    }
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px' }}>
        <TextField
          placeholder="Search 5 records..."
          variant="outlined"
          size="small"
          value={search}
          onChange={handleSearchChange}
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={handleCreateClick}
        >
          Create
        </Button>
      </div>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox"></TableCell>
              <TableCell>ORGANIZATION ID</TableCell>
              <TableCell>
                ORGANIZATION INFO
                <Select
                  value={sort}
                  onChange={handleSortChange}
                  displayEmpty
                  size="small"
                >
                  <MenuItem value="">Sort by (Organization Info)</MenuItem>
                  <MenuItem value="asc">A-Z</MenuItem>
                  <MenuItem value="desc">Z-A</MenuItem>
                </Select>
              </TableCell>
              <TableCell>CREATE DATE</TableCell>
              <TableCell>WEBSITE</TableCell>
              <TableCell>PIC INFO</TableCell>
              <TableCell>STATUS</TableCell>
              <TableCell>ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {organizations.map((org) => (
              <TableRow hover key={org.id}>
                <TableCell padding="checkbox">
                  <input type="checkbox" />
                </TableCell>
                <TableCell>{org.id}</TableCell>
                <TableCell>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar sx={{ mr: 2, width: 72, height: 72 }} src={org.logo}>
                       {!org.logo && org.name ? org.name.charAt(0) : ''}
                    </Avatar>
                    <div>
                      <div>{org.name}</div>
                      <div>{org.businessRegOld}</div>
                      <div>{org.businessRegNew}</div>
                    </div>
                  </div>
                </TableCell>
                <TableCell>{org.createdDate.toDate().toLocaleDateString()}</TableCell>
                <TableCell>{org.website}</TableCell>
                <TableCell>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                      <div>{org.contactPerson.name}</div>
                      <div>{org.contactPerson.email}</div>
                      <div>{org.contactPerson.phone}</div>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <Chip label={org.status} color={getStatusColor(org.status)} />
                </TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => handleManage(org.id)}><Visibility /></IconButton>
                  {/* <IconButton size="small"><Edit /></IconButton> */}
                  {/* <IconButton size="small"><Delete /></IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px' }}>
        <div>
          Rows per page: 
          <Select value={20} size="small">
            <MenuItem value={20}>20</MenuItem>
          </Select>
        </div>
        <Pagination
          count={Math.ceil(totalCount / 20)}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </div>
    </Paper>
  );
};

export default Organization;